import { render } from "./defaultTag.vue?vue&type=template&id=728ed1f4"
import script from "./defaultTag.vue?vue&type=script&lang=js"
export * from "./defaultTag.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andrew/Documents/Code/SeoBiz/AdminApp/FrontEnd/clientapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__